import fetch from 'node-fetch';
import { toastr } from 'react-redux-toastr';
import history from '../../../../history';
import moment from 'moment';
import { toPlacementValue } from '../../../../helpers/contentPagePlacement';

async function submit(values, dispatch) {
  if (values.content === null || values.content === '<p><br></p>' || values.content === '<p> </p>') {
    toastr.error("Error", "Please Add  Content");
  } else {
    const variables = {
      ...values,
      placement: toPlacementValue(values.placement),
      startDate: values.startDate ? moment(values.startDate).utc().toISOString() : null,
      endDate: values.endDate ? moment(values.endDate).utc().toISOString() : null,
      locationIds: values.locationIds || [],
    };

    const mutation = `
          mutation addContentPageDetails(
            $id: Int,
            $metaTitle: String,
            $metaDescription: String,
            $pageUrl: String,
            $pageTitle: String,
            $content: String,
            $pageBanner: String,
            $placement: String,
            $startDate: String,
            $endDate: String,
            $priority: Int,
            $locationIds: [Int]
          ) {
            addContentPageDetails(
              id: $id,
              metaTitle: $metaTitle,
              metaDescription: $metaDescription,
              pageUrl: $pageUrl,
              pageTitle: $pageTitle,
              content: $content,
              pageBanner: $pageBanner,
              placement: $placement,
              startDate: $startDate,
              endDate: $endDate,
              priority: $priority,
              locationIds: $locationIds
            ) {
                status
                errorMessage
            }
          }
          `;

    const response = await fetch('/graphql', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        query: mutation,
        variables
      }),
      credentials: 'include'
    });

    const { data } = await response.json();


    if (data?.addContentPageDetails?.status === "200") {
      toastr.success("Content Page", `Changes are ${values.id ? 'updated' : 'added'} successfully!`);
      history.push('/siteadmin/contentpage/manage')
    }
    else if (data?.addContentPageDetails?.status === "400") {
      toastr.error("Failed!", data.addContentPageDetails.errorMessage || "The page URL already exist!");
    }
    else {
      toastr.error("Failed!", data?.addContentPageDetails?.errorMessage || "Updating Content Page Details failed");
    }


  }
}

export default submit;